import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ListViewIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M18.9643 17.2315C19.6744 17.2315 20.25 17.7953 20.25 18.4907C20.25 19.1862 19.6744 19.75 18.9643 19.75H4.53571C3.82563 19.75 3.25 19.1862 3.25 18.4907C3.25 17.7953 3.82563 17.2315 4.53571 17.2315H18.9643Z"
				fill="currentColor"
			/>
			<path
				d="M18.9643 10.4907C19.6744 10.4907 20.25 11.0545 20.25 11.75C20.25 12.4455 19.6744 13.0093 18.9643 13.0093H4.53571C3.82563 13.0093 3.25 12.4455 3.25 11.75C3.25 11.0545 3.82563 10.4907 4.53571 10.4907H18.9643Z"
				fill="currentColor"
			/>
			<path
				d="M18.9643 3.75C19.6744 3.75 20.25 4.31379 20.25 5.00926C20.25 5.70473 19.6744 6.26852 18.9643 6.26852H4.53571C3.82563 6.26852 3.25 5.70473 3.25 5.00926C3.25 4.31379 3.82563 3.75 4.53571 3.75H18.9643Z"
				fill="currentColor"
			/>
			<path
				d="M18.9643 17.2315C19.6744 17.2315 20.25 17.7953 20.25 18.4907C20.25 19.1862 19.6744 19.75 18.9643 19.75H4.53571C3.82563 19.75 3.25 19.1862 3.25 18.4907C3.25 17.7953 3.82563 17.2315 4.53571 17.2315H18.9643Z"
				stroke="black"
			/>
			<path
				d="M18.9643 10.4907C19.6744 10.4907 20.25 11.0545 20.25 11.75C20.25 12.4455 19.6744 13.0093 18.9643 13.0093H4.53571C3.82563 13.0093 3.25 12.4455 3.25 11.75C3.25 11.0545 3.82563 10.4907 4.53571 10.4907H18.9643Z"
				stroke="black"
			/>
			<path
				d="M18.9643 3.75C19.6744 3.75 20.25 4.31379 20.25 5.00926C20.25 5.70473 19.6744 6.26852 18.9643 6.26852H4.53571C3.82563 6.26852 3.25 5.70473 3.25 5.00926C3.25 4.31379 3.82563 3.75 4.53571 3.75H18.9643Z"
				stroke="black"
			/>
		</svg>
	);
}

ListViewIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ListViewIcon;
